import ObjectsToCsv from 'objects-to-csv';
import { dateFormatter } from './dateUtils';

export async function tableToCsv(rows, header) {
    const tableData = rows.map(r => {
        return header.reduce((acc, h) => {
          acc[h.label] = h.format === 'date' ? dateFormatter(r[h.id]) : r[h.id];
          return acc;
        }, {});
    });

    const csv = new ObjectsToCsv(tableData);
    return await csv.toString();
}